import { render, staticRenderFns } from "./modalProduto.vue?vue&type=template&id=c39ce4ca&"
import script from "./modalProduto.vue?vue&type=script&lang=js&"
export * from "./modalProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports